var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_9503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.76758 5.77075V14.3719C2.76758 14.8037 3.11766 15.1538 3.5495 15.1538H9.80484H14.121H16.0602C16.492 15.1538 16.8421 14.8037 16.8421 14.3719V9.83672V5.77075C16.8421 5.33891 16.492 4.98883 16.0602 4.98883H9.80484H4.52689H3.5495C3.11766 4.98883 2.76758 5.33891 2.76758 5.77075Z",
    fill: "url(#paint0_linear_1389_9503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07033 11.5991L3.26668 13.5868C2.92474 13.9636 3.19212 14.5673 3.70098 14.5673H14.541C15.0499 14.5673 15.3173 13.9636 14.9753 13.5868L11.5101 9.76798C11.2774 9.5115 10.8742 9.5115 10.6415 9.76798L7.89372 12.7961C7.66099 13.0526 7.25786 13.0526 7.02513 12.7961L5.93892 11.5991C5.70619 11.3426 5.30306 11.3426 5.07033 11.5991Z",
    fill: "url(#paint1_linear_1389_9503)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.36225,
    cy: 10.3645,
    r: 1.07514,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1389_9503)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1389_9503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 8.89078C14.2639 9.11838 13.9003 9.24447 13.5249 9.25061C12.3022 9.25061 11.6035 7.85321 11.6035 7.85321C11.8208 7.4483 12.1221 7.09453 12.4874 6.81564M13.1581 6.49774C13.2784 6.46959 13.4015 6.45552 13.5249 6.45581C14.7477 6.45581 15.4464 7.85321 15.4464 7.85321C15.3403 8.05157 15.2139 8.23832 15.0691 8.41042M13.8952 8.22352C13.8473 8.275 13.7894 8.3163 13.7251 8.34494C13.6609 8.37358 13.5915 8.38898 13.5211 8.39022C13.4507 8.39147 13.3809 8.37852 13.3156 8.35217C13.2504 8.32581 13.1911 8.28658 13.1413 8.23682C13.0916 8.18706 13.0523 8.12779 13.026 8.06254C12.9996 7.99729 12.9867 7.9274 12.9879 7.85704C12.9892 7.78668 13.0046 7.71729 13.0332 7.65301C13.0618 7.58873 13.1031 7.53087 13.1546 7.4829",
    stroke: "white",
    strokeWidth: 0.349349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6035 5.93182L15.4464 9.77466",
    stroke: "white",
    strokeWidth: 0.349349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1389_9503",
    x: 10.38,
    y: 4.97663,
    width: 6.31615,
    height: 5.7791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.201596
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1389_9503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1389_9503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9503",
    x1: 2.26773,
    y1: 6.44422,
    x2: 16.9019,
    y2: 19.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E372FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9503",
    x1: 9.121,
    y1: 9.28937,
    x2: 9.121,
    y2: 14.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_9503"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.76758,
    y: 4.98883,
    width: 14.0745,
    height: 10.1649,
    rx: 0.781918,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1389_9503"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.7832,
    y: 5.37982,
    width: 5.51029,
    height: 4.9727,
    rx: 1.07518,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon4);
export default __webpack_public_path__ + "static/media/camera_card_icon4.e55542dab2a00e0664bb4b40d9d27c78.svg";
export { ForwardRef as ReactComponent };